/*
 *   File : reducer.js
 *   Author URI : https://evoqins.com
 *   Description : Global state maintain and  update file
 *   Integrations : axios
 *   Version : v1.1
*/

const INITIAL_STATE = {
    UNREAD_NOTIFICATION: undefined,
    USER_DATA: undefined,
    USER_ID: undefined,
    ACCESS_TOKEN: undefined, // For accessing App features
};

// Reducer function

export default function Reducer(state = INITIAL_STATE, action) {

    switch (action.type) {
        case "UPDATE_ACCESS_TOKEN": {
            return {
                ...state,
                ACCESS_TOKEN: action.payload,
            }
        }
        case "UPDATE_USER_DATA": {
            return {
                ...state,
                USER_DATA: action.payload,
            }
        }
        case "UPDATE_USER_ID": {
            return {
                ...state,
                USER_ID: action.payload,
            }
        }
        case "UPDATE_NOTIFICATION_COUNT": {
            return {
                ...state,
                UNREAD_NOTIFICATION: action.payload,
            }
        }
        case "CLEAR_STORE": {
            return { ...INITIAL_STATE };
        }
        default: return state;
    }

};